import { render, staticRenderFns } from "./SquaredIcon.vue?vue&type=template&id=3323d271&scoped=true"
import script from "./SquaredIcon.vue?vue&type=script&lang=js"
export * from "./SquaredIcon.vue?vue&type=script&lang=js"
import style0 from "./SquaredIcon.vue?vue&type=style&index=0&id=3323d271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323d271",
  null
  
)

export default component.exports